export enum LicenseStatus {
  ACTIVE,
  WARNING,
  EXPIRED,
}
